module.exports = __webpack_public_path__ + "static/media/flower_icon.18c14085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/flower_icon.png
// module id = 1592
// module chunks = 0